module.exports = __webpack_public_path__ + "static/media/joint.c9b4b0a2.svg";